import React, { useEffect, useState } from "react";
import { Button, Grid, Typography, Paper, Divider } from "@mui/material";
import axios from "axios";
import { Stack } from "react-bootstrap";

const SlotSelection = ({ doctorId, onSlotSelect }) => {
  const [slots, setSlots] = useState([]);

  function formatDateToReadable(dateStr) {
    const date = new Date(dateStr);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    // Get the ordinal suffix (st, nd, rd, th)
    const getOrdinalSuffix = (n) => {
      if (n > 3 && n < 21) return "th";
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
  }

  useEffect(() => {
    if (doctorId) {
      try {
        axios
          .get(
            `https://kz-appointments-api.onrender.com/api/doctors/${doctorId}/slots`
          )
          .then((res) => setSlots(res.data.slots))
          .catch((error) => {
            setSlots([]);
            console.error("Error fetching slots:", error);
          });
      } catch (error) {
        setSlots([]);
        console.error("Error fetching slots:", error);
      }
    }
  }, [doctorId]);

  if (!slots.length)
    return <Typography>No available slots for this doctor.</Typography>;

  const dayMap = {
    0: "Mon",
    1: "Tue",
    2: "Wed",
    3: "Thu",
    4: "Fri",
  };

  return (
    <Stack direction="row">
      {slots.map((slot, idx) => (
        <Stack direction="row" spacing={1} key={idx}>
          <Typography variant="h4" color="primary">
            {formatDateToReadable(slot.date)}
          </Typography>
          <Divider />
          <Grid container spacing={1} sx={{ mb: 2, mt: 1 }}>
            {slot.slots.map((time, idx) => (
              <Grid container item key={time} xs={3}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() =>
                    onSlotSelect({
                      start: time.start,
                      end: time.end,
                      date: slot.date,
                    })
                  }
                >
                  {`${time.start} - ${time.end}`}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Stack>
      ))}
    </Stack>
  );
};

export default SlotSelection;
